// src/features/dashboard/components/RevenueOverview.tsx
import { SalesChart } from './SalesChart';
import type { DailySalesPoint } from '../types/dashboard.types';

interface RevenueOverviewProps {
  data: DailySalesPoint[];
  isInitialLoading: boolean;
}

/**
 * Composition-only wrapper: `SalesChart` is the single source of truth for
 * revenue, so `RevenueOverview` still renders it and nothing else in terms
 * of content or data. `CustomersChart` is a separate business-insight
 * widget and is intentionally not nested here -- it keeps its own place in
 * the layout, unchanged.
 *
 * The `<section>` header below is purely presentational framing (eyebrow +
 * title) that gives this widget the same "insight section" chrome as the
 * rest of the Business Insights Center. No new data, no derived metrics:
 * props pass straight through to the existing, untouched `SalesChart`
 * contract.
 */
export function RevenueOverview({ data, isInitialLoading }: RevenueOverviewProps) {
  return (
    <section className="vania-insight-section" data-animate="fade-in">
      <header className="vania-insight-section__header">
        <span className="vania-insight-eyebrow">تحلیل کسب‌وکار</span>
        <h2 className="vania-insight-title">نمای کلی درآمد</h2>
      </header>

      <div className="vania-insight-section__body">
        <SalesChart data={data} isInitialLoading={isInitialLoading} />
      </div>
    </section>
  );
}
